module.exports = __webpack_public_path__ + "static/img/Jake-Trbojevic.52576d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Trbojevic.jpg
// module id = rNUX
// module chunks = 0